import React, { useEffect, useMemo, useState } from "react";
import { ENTITY_TYPE } from "src/shared/config/src";
import { fetchObservationReactionsList, fetchPostReactionsList } from "src/shared/services/src";
import { ChildrenStoreData, ReactionCommentData } from "src/shared/types/src";
import { useAppDispatch, useAppSelector } from "../services/store";
import { getCurrentChild } from "src/shared/redux-state/src";
import { getNameInitials } from "src/shared/utils/src";
import { GlobalErrorActions } from "src/shared/redux-state/src/lib/globalError/GlobalErrorSlice";
import ProfileImageView from "./commonComponents/ProfileImageView";
import ReactionListLoader from "./loader/ReactionListLoader";

type iProps = { 
    entityType: string, 
    entityId: string 
}
const ReactionList: React.FC<iProps> = ({ entityType, entityId }) => {

    const dispatch = useAppDispatch();
    const [reactionsLoading, setReactionsLoading] = useState<boolean>(false);
    const [reactionList, setReactionList] = useState<ReactionCommentData[]>([]);
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    useEffect(() => {
        fetchUsersWhoReacted(entityId);
    }, [entityId]);

    const fetchUsersWhoReacted = async (entityId: string) => {
        try {
            setReactionsLoading(true);
            let response;
            if (entityType === ENTITY_TYPE.OBSERVATION) {
                response = await fetchObservationReactionsList({ child: currentChild, observationId: entityId });
                console.log("Response in compomnent is : ", response);
                if (response && Object.keys(response).length) {
                    setReactionList(response?.likes?.data ?? []);
                } else setReactionList([]);
            } else if (entityType === ENTITY_TYPE.EYENGAGE) {
                response = await fetchPostReactionsList({ child: currentChild, postId: entityId });
                console.log("Response in compomnent is : ", response);
                if (response && Object.keys(response).length) {
                    setReactionList(response?.reactions?.likes?.data ?? []);
                } else setReactionList([]);
            }
        } catch (error) {
            setReactionList([]);
            await dispatch(GlobalErrorActions.setError({ isError: true, message: 'Could not fetch reactions.' }));
        } finally {
            setReactionsLoading(false);
        }
    }

    const NoLikes = () => {
        return (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '330px' }}>
                <p className="mg-b-0 fs-14 text-black">No likes yet</p>
            </div>
        )
    }

    return (
        <div style={{ minHeight: '330px' }}>
            {
                reactionsLoading ? 
                <>
                    <ReactionListLoader />
                </> :
                <>
                    {reactionList && !reactionList.length ? <NoLikes /> : <>{reactionList.map((item, index) => <ReactionListItem reactionItem={item} index={index} />)}</>}
                </>
            }
        </div>
    )
}

const ReactionListItem = ({ reactionItem, index }: { reactionItem: ReactionCommentData, index: number }) => {

    const [nameInitials, setNameInitials] = useState('');

    useEffect(() => {
        if (reactionItem.user && reactionItem.user.name && !reactionItem.user.photo) {
            const nameInitials = getNameInitials(reactionItem.user.name);
            setNameInitials(nameInitials);
        }
    }, [reactionItem]);

    return (
        <div className={`mx-n-15 pd-x-15 d-flex align-items-center ${index === 0 ? 'pd-b-15' : 'pd-y-15 border-top border-gray-700'}`}>
            {
                reactionItem.user ? <ProfileImageView 
                    name={reactionItem.user.name}
                    imageUrl={reactionItem.user.photo}
                /> : null
            }
            <div className="fs-14 text-black mg-l-10">
                { reactionItem.user.name || '-' }
            </div>
        </div>
    )
}

export default ReactionList;